import { AlarmStateModel, SoundState, LogListType, UserLogListType, MessageListType, AnswerMessage, MessageNotification, ConnectionIcons, EnergyAnalyzerModel, EnergyModel, EnergyMonitor, UserResetPassword, SoundPlayingStatus, TimezoneType, DateState, SunTimeType, DetailedRFTestResponse, HardwareVersionCompatibility, DeviceVersionListResponse, SystemRestart, WorkerConfigPanelSettings, OnboardingUser, AuthenticatedWithPinCodeResponse, RemoteUpdateState } from "./state"
import { createAction } from '../../base/fsa';
import { IntercomModel } from '../../types/intercom';
import { ControlModel } from "../../types/control";
import { WorkerConfigModel } from "../../types/worker-config";
import { LucentRGBSettingsModel } from "../../types/lucent-rgb-settings";

export const controlSendErrorAction = createAction(
    resolve => (controlId: string, hasError: boolean) => resolve({ controlId, hasError }),
);

export const inputSendErrorAction = createAction(
    resolve => (inputId: string, hasError: boolean) => resolve({ inputId, hasError }),
);

export const mediaStatusUpdatedAction = createAction(
    resolve => (status: string) => resolve(status),
);

export const setIntercomStatusAction = createAction(
    resolve => (status: string, is_incoming_call: boolean, id = '', name = '', call_time = 0) => resolve({
        status,
        is_incoming_call,
        id,
        name,
        call_time
    }),
);

export const setIntercomInfoAction = createAction(
    resolve => (info: IntercomModel) => resolve(info),
);

export const setBellStatusAction = createAction(
    resolve => (status: string) => resolve(status),
);

export const setScreenSaverStatusAction = createAction(
    resolve => (status: string) => resolve(status),
);

export const entityDeletedAction = createAction(
    resolve => (id: string, type: string) => resolve({ id, type }),
);

export const setEntityListAction = createAction(
    resolve => (entities: unknown, type: string) => resolve({ entities: entities || [], type }),
);

export const setInitialEntityListAction = createAction(
    resolve => (entities: unknown, type: string) => resolve({ entities: entities || [], type }),
);

export const entityCreatedAction = createAction(
    resolve => (entity: unknown, type: string) => resolve({ entity, type }),
);

export const entityUpdatedAction = createAction(
    resolve => (entity: { id: string, [key: string]: unknown }, type: string) => resolve({ entity, type }),
);

export const setDefaultAlarmStateAction = createAction(
    resolve => (alarmStateModel: AlarmStateModel) => resolve(alarmStateModel),
);

export const setSoundStateAction = createAction(
    resolve => (soundState: SoundState) => resolve(soundState),
);

export const setGroupControlsAction = createAction(
    resolve => (groupControlList: ControlModel[]) => resolve(groupControlList),
);

export const setPasswordAction = createAction(
    resolve => (passwordStatus: boolean) => resolve(passwordStatus),
);

export const setPasswordActionV2 = createAction(
    resolve => (passwordStatusV2: boolean) => resolve(passwordStatusV2),
);

export const setVersionAction = createAction(
    resolve => (versionStatus: string) => resolve(versionStatus),
);

export const setRemoteUpdateConfig = createAction(
    resolve => (config: RemoteUpdateState) => resolve(config)
)

export const setLogAction = createAction(
    resolve => (logList: LogListType[]) => resolve(logList)
);

export const setUserLogAction = createAction(
    resolve => (userLogList: UserLogListType[]) => resolve(userLogList)
);

export const setConnectionIconsAction = createAction(
    resolve => (connectionIcons: ConnectionIcons) => resolve(connectionIcons)
)

export const setRSSIAction = createAction(
    resolve => (rssiStatus: string) => resolve(rssiStatus),
);

export const setEnergyAnalyzer = createAction(
    resolve => (energyState: EnergyAnalyzerModel) => resolve(energyState)
);

export const setEnergyInfo = createAction(
    resolve => (energyInfo: EnergyModel[]) => resolve(energyInfo)
);

export const setEnergyUpdated = createAction(
    resolve => (energyUpdated: EnergyMonitor) => resolve(energyUpdated)
);
export const setMessageAction = createAction(
    resolve => (messageList: MessageListType) => resolve(messageList),
);

export const setMessageStatusAction = createAction(
    resolve => (messageStatus: AnswerMessage) => resolve(messageStatus),
);

export const setMessageNotification = createAction(
    resolve => (messageNotification: MessageNotification) => resolve(messageNotification)
);

export const setReadAllTempFunc = createAction(
    resolve => (readAllTempFunc: string) => resolve(readAllTempFunc),
);

export const setSupervisorConfigListAction = createAction(
    resolve => (sup_config: unknown, type: string) => resolve({ sup_config: sup_config || [], type })
)

export const setSupervisorConfigUpdateAction = createAction(
    resolve => (sup_config: { id: string;[key: string]: unknown }, type: string) => resolve({ sup_config, type })
)

export const setWorkerConfig = createAction(
    resolve => (workerConfig: WorkerConfigModel) => resolve(workerConfig)
)

export const setUserResetPassword = createAction(
    resolve => (userResetPassword: UserResetPassword) => resolve(userResetPassword),
);

export const setSoundPlayingStatusAction = createAction(
    resolve => (soundPlayingStatus: SoundPlayingStatus) => resolve(soundPlayingStatus)
)

export const setTouchMessageAction = createAction(
    resolve => (touchMessageStatus: { message: boolean }) => resolve(touchMessageStatus)
)

export const setPingTestAction = createAction(
    resolve => (pingTest: string) => resolve(pingTest)
)

export const setTraceRouteAction = createAction(
    resolve => (traceRouteTest: string) => resolve(traceRouteTest)
)

export const setMatchStateAction = createAction(
    resolve => (matchState: string) => resolve(matchState)
)

export const setMousePointerAction = createAction(
    resolve => (mousePointerStatus: boolean) => resolve(mousePointerStatus)
)

export const setHomepageItemsActions = createAction(
    resolve => (favoritesPage: boolean) => resolve(favoritesPage)
)

export const setTemporaryUserAction = createAction(
    resolve => (temporaryUserStatus: string) => resolve(temporaryUserStatus)
)

export const setExternalUsbAction = createAction(
    resolve => (externalUsbStatus: boolean) => resolve(externalUsbStatus)
)

export const setTimezoneAction = createAction(
    resolve => (timezoneList: TimezoneType[]) => resolve(timezoneList)
)

export const setTimezoneOffsetAction = createAction(
    resolve => (timezoneOffset: DateState) => resolve(timezoneOffset)
)

export const setSuntimeAction = createAction(
    resolve => (suntime: SunTimeType) => resolve(suntime)
)

export const setResetCountdown = createAction(
    resolve => (somResetCountdown: string) => resolve(somResetCountdown)
)

export const setDetailedRFTest = createAction(
    resolve => (detailedRFTestResponse: DetailedRFTestResponse) => resolve(detailedRFTestResponse)
)

export const setHardwareVersionCompatibility = createAction(
    resolve => (hardwareVersionCompatibility: HardwareVersionCompatibility) => resolve(hardwareVersionCompatibility)
)
export const setDeviceVersionListResponse = createAction(
    resolve => (deviceVersionListResponse:  DeviceVersionListResponse) => resolve(deviceVersionListResponse)
)
export const setLucentRGBSettings = createAction(
    resolve => (lucentRGBSettings: LucentRGBSettingsModel) => resolve(lucentRGBSettings)
)

export const setSelectedBackgroundAction = createAction(
    resolve => (backgroundImageId: string) => resolve(backgroundImageId)
)

export const setSystemRestartAction = createAction(
    resolve => (systemRestartSettings: SystemRestart) => resolve(systemRestartSettings)
)

export const setWorkerConfigPanelAction = createAction(
    resolve => (workerConfigPanelSettings: WorkerConfigPanelSettings) => resolve(workerConfigPanelSettings)
)
export const setOnboardingListAction = createAction(
    resolve => (onboardingList: OnboardingUser) => resolve(onboardingList)
)
export const setAuthenticatedWithPinCode = createAction(
    resolve => (authenticatedWithPinCode: AuthenticatedWithPinCodeResponse) => resolve(authenticatedWithPinCode)
)
export const setResetCloudUserAlarmPassword = createAction(
    resolve => (user_name: string) => resolve(user_name)
)
export const setCloudStatus = createAction(
    resolve => (is_enabled: boolean) => resolve(is_enabled)
)
export const setCloudConnectionStatusAction = createAction(
    resolve => (cloudEvent: string) => resolve(cloudEvent)
)